const SHOW_TOUR_HINT = 'components/layout/sidebar/SHOW_TOUR_HINT';
const HIDE_TOUR_HINT = 'components/layout/sidebar/HIDE_TOUR_HINT';

const initialState = {
  runTourHint: false,
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SHOW_TOUR_HINT:
      return {
        ...state,
        runTourHint: true,
      };
    case HIDE_TOUR_HINT:
      return {
        ...state,
        runTourHint: false,
      };
    default:
      return state;
  }
};

export function showTourHint() {
  return {
    type: SHOW_TOUR_HINT,
  };
}

export function hideTourHint() {
  return {
    type: HIDE_TOUR_HINT,
  };
}
